module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dispatchReady"
    }
  }, [_c('el-col', {
    staticClass: "searthPart",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.searchForm.address),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请输入编组名称"
    },
    model: {
      value: (_vm.searchForm.label),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "label", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.label"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "placeholder": "渠道"
    },
    model: {
      value: (_vm.searchForm.orderIdentifierList),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "orderIdentifierList", $$v)
      },
      expression: "searchForm.orderIdentifierList"
    }
  }, _vm._l((_vm.OrderNolList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "省"
    },
    on: {
      "change": _vm.choseProvince
    },
    model: {
      value: (_vm.searchForm.province),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "province", $$v)
      },
      expression: "searchForm.province"
    }
  }, _vm._l((_vm.provinceList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.searchForm.province) ? _c('el-form-item', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "市"
    },
    on: {
      "change": _vm.choseCity
    },
    model: {
      value: (_vm.searchForm.city),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "city", $$v)
      },
      expression: "searchForm.city"
    }
  }, _vm._l((_vm.cityList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.searchForm.city) ? _c('el-form-item', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "区"
    },
    model: {
      value: (_vm.searchForm.county),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "county", $$v)
      },
      expression: "searchForm.county"
    }
  }, _vm._l((_vm.areaList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择预派时间"
    },
    model: {
      value: (_vm.periodType),
      callback: function($$v) {
        _vm.periodType = $$v
      },
      expression: "periodType"
    }
  }, _vm._l((_vm.pickingTimeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.paraName,
        "value": item.paraValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": _vm.getSendOrderList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "fr"
  }, [_c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "600px",
      "text-align": "right"
    }
  }, [(_vm.basicsAuth.newLable) ? _c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": _vm.newGroup
    }
  }, [_vm._v("新建编组")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.sendGroupOrders) ? _c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.newDispatchDialog(0)
      }
    }
  }, [_vm._v("批量派单")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.newDispatchDialog(1)
      }
    }
  }, [_vm._v("批量改派")]), _vm._v(" "), (_vm.basicsAuth.newLable) ? _c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": _vm.cancelDispatchGroup
    }
  }, [_vm._v("批量解散")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.downLoad.exportExcel('tableId')
      }
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer",
      "margin-left": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-card', {
    staticClass: "box-card",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "tableId",
      "data": _vm.returnData,
      "span-method": _vm.objectSpanMethod,
      "row-class-name": _vm.tableRowClassName,
      "border": "",
      "height": _vm.tableHeight,
      "header-cell-style": {
        'text-align': 'center'
      }
    },
    on: {
      "cell-mouse-leave": _vm.cellMouseLeave,
      "cell-mouse-enter": _vm.cellMouseEnter
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "label",
      "width": "100",
      "label": "编组名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          attrs: {
            "checked": scope.row.selected
          },
          on: {
            "change": function($event) {
              return _vm.checkFuc(scope.row)
            }
          },
          model: {
            value: (scope.row.selected),
            callback: function($$v) {
              _vm.$set(scope.row, "selected", $$v)
            },
            expression: "scope.row.selected"
          }
        }), _vm._v("  " + _vm._s(scope.row.label) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "width": "150",
      "label": "机型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.label) ? _c('el-checkbox', {
          attrs: {
            "checked": scope.row.selected
          },
          model: {
            value: (scope.row.selected),
            callback: function($$v) {
              _vm.$set(scope.row, "selected", $$v)
            },
            expression: "scope.row.selected"
          }
        }) : _vm._e(), _vm._v("  " + _vm._s(scope.row.modelName) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "align": "center",
      "prop": "colorName",
      "label": "颜色"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "align": "center",
      "label": "故障"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.faultSubclass), function(item, index) {
          return _c('span', {
            key: index,
            staticStyle: {
              "display": "block"
            }
          }, [_vm._v(_vm._s(item.faultSubclassShortName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "100",
      "prop": "onsiteDate",
      "label": "预约日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "120",
      "label": "预约时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.onsiteTimeStart) + "~" + _vm._s(scope.row.onsiteTimeEnd))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "align": "center",
      "label": "区域"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.countyName) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "330",
      "align": "left",
      "label": "地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.address) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "110",
      "align": "center",
      "label": "工程师"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.serviceType == 'QS' || scope.row.serviceType == 'QD') && scope.row.isFetch != 2) ? _c('span', [_vm._v(_vm._s(scope.row.fetchName))]) : (scope.row.sendMachineWay == 3) ? _c('span', [_vm._v(_vm._s(scope.row.sendName))]) : _c('span', [_vm._v(_vm._s(scope.row.engineerName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "left",
      "prop": "handleRemark",
      "width": "800",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "label": "订单渠道"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.orderIdentifier, 'order_identifier')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "align": "center",
      "fixed": "right",
      "label": "完成度"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.adminStatus, 'admin_status')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "220",
      "prop": "orderNo",
      "label": "订单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(scope.row.orderNo) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "align": "center",
      "fixed": "right",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [((scope.row.adminStatus == '38' || scope.row.adminStatus == '03') && _vm.basicsAuth.sendOrders) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.newModel(scope.row, 0)
            }
          }
        }, [_vm._v("派单")]) : _vm._e(), _vm._v(" "), ((scope.row.adminStatus != '38' && scope.row.adminStatus != '03' && _vm.basicsAuth.revertOrders)) ? _c('el-button', {
          staticStyle: {
            "padding": "7px"
          },
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.newModel(scope.row, 1)
            }
          }
        }, [_vm._v("改派")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left",
      "line-height": "80px",
      "font-size": "20px",
      "color": "#000"
    }
  }, [_vm._v("总条数：" + _vm._s(_vm.returnData.length) + "/条")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textModelMenu[_vm.dialogModelStatus],
      "visible": _vm.dislogModel,
      "close-on-click-modal": false,
      "width": "700px",
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogModel = $event
      },
      "close": function($event) {
        return _vm.emptyModelDialog('modelForm')
      }
    }
  }, [_c('el-form', {
    ref: "modelForm",
    attrs: {
      "model": _vm.modelForm,
      "label-width": "95px",
      "label-position": _vm.labelPosition,
      "rules": _vm.modelFormRules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": "",
      "placeholder": "请输入关联工单"
    },
    model: {
      value: (_vm.modelForm.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "orderNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在区域"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.countyName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "countyName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.countyName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预约时间"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.time),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "time", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.colorName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "colorName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.colorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "已派工程师"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.engineerName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "engineerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.engineerName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在城市"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.cityName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "cityName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.cityName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址详情"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.address),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "address", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备详情"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": ""
    },
    model: {
      value: (_vm.modelForm.modelDetail),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelDetail", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.modelDetail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障详情",
      "prop": "faultSubclassStr"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "disabled": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.modelForm.faultSubclassStr),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "faultSubclassStr", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.faultSubclassStr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工程师",
      "prop": "engineerId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filter-method": _vm.PinyinMatch,
      "filterable": "",
      "placeholder": "请选择改派工程师",
      "clearable": ""
    },
    on: {
      "change": _vm.changeEnginner
    },
    model: {
      value: (_vm.modelForm.engineerId),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "engineerId", $$v)
      },
      expression: "modelForm.engineerId"
    }
  }, _vm._l((_vm.pickingPointEngineerList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogModelStatus == 'create') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addModelFormSubmitBtn('modelForm', 0)
      }
    }
  }, [_vm._v("确认")]) : _vm._e(), _vm._v(" "), (_vm.dialogModelStatus == 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addModelFormSubmitBtn('modelForm', 1)
      }
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textGroupMenu[_vm.dialogGroupStatus],
      "visible": _vm.dialogGropFormVisible,
      "width": "400px"
    },
    on: {
      "click": _vm.emptyGroupDialog,
      "update:visible": function($event) {
        _vm.dialogGropFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "groupForm",
    attrs: {
      "model": _vm.groupForm,
      "label-position": _vm.labelPosition
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编组名称："
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "请输入编组名称"
    },
    model: {
      value: (_vm.groupForm.label),
      callback: function($$v) {
        _vm.$set(_vm.groupForm, "label", $$v)
      },
      expression: "groupForm.label"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.emptyGroupDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.dialogGroupStatus == 'update') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.setOrderLabelFuc
    }
  }, [_vm._v("保 存")]) : _vm._e(), _vm._v(" "), (_vm.dialogGroupStatus == 'create') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.setOrderLabelFuc
    }
  }, [_vm._v("新 建")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textBatchMenu[_vm.dialogBatchStatus],
      "title": "批量派单",
      "visible": _vm.dialogDispatchForm,
      "width": "400px"
    },
    on: {
      "click": _vm.emptyDispatchDialog,
      "update:visible": function($event) {
        _vm.dialogDispatchForm = $event
      }
    }
  }, [_c('el-form', {
    ref: "dispatchForm",
    attrs: {
      "model": _vm.dispatchForm,
      "label-position": _vm.labelPosition,
      "rules": _vm.dispatchFormRules,
      "label-width": "85px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编组名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "212px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.dispatchForm.label),
      callback: function($$v) {
        _vm.$set(_vm.dispatchForm, "label", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "dispatchForm.label"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单数量："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "212px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.dispatchForm.nums),
      callback: function($$v) {
        _vm.$set(_vm.dispatchForm, "nums", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "dispatchForm.nums"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "工程师：",
      "prop": "engineerId"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择改派工程师",
      "clearable": ""
    },
    model: {
      value: (_vm.dispatchForm.engineerId),
      callback: function($$v) {
        _vm.$set(_vm.dispatchForm, "engineerId", $$v)
      },
      expression: "dispatchForm.engineerId"
    }
  }, _vm._l((_vm.pickingPointEngineerList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.emptyDispatchDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.dialogBatchStatus == 'create') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.dispatchFormSubmitBtn('dispatchForm')
      }
    }
  }, [_vm._v("确 认")]) : _vm._e(), _vm._v(" "), (_vm.dialogBatchStatus == 'update') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.dispatchRevertFormSubmitBtn('dispatchForm')
      }
    }
  }, [_vm._v("确 认")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-2e049702","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dispatchOrder/dispatchReady.vue
// module id = 1615
// module chunks = 0